import { IInfoCookies, IInfoCookiesValidation } from '../types/infoCookies';
import { defaulLangTextValidation, defaultTTranslate } from '~/constants/main';

export const defaultInfoCookies: IInfoCookies = {
  title: defaultTTranslate,
  message: defaultTTranslate,
  cookiesEnabled: 0,
};

export const defaultInfoCookiesValidation: IInfoCookiesValidation = {
  isValid: true,
  title: defaulLangTextValidation,
};
